import type { RegionParameters } from '@innovamat/glow-api-client';

import { useRegionParameters } from '../../contents/hooks/use-region-parameters';
import { getRegionalNumber } from '../utils/regional-number';

type Props = {
  number?: number | null;
  regionParameters?: RegionParameters;
  fixedTo?: number;
  forceDecimals?: boolean;
};

type UseRegionalNumber = {
  regionalNumber: string | undefined;
  isLoading: boolean;
};

function useRegionalNumber({
  number,
  regionParameters,
  fixedTo = 1,
  forceDecimals = false,
}: Props): UseRegionalNumber {
  const { isLoading, regionParameters: fetchedRegionParameters } =
    useRegionParameters({});

  const parameters = regionParameters ?? fetchedRegionParameters;

  return {
    isLoading,
    regionalNumber: getRegionalNumber({
      number,
      fixedTo,
      forceDecimals,
      parameters,
    }),
  };
}

export { useRegionalNumber };
